import { NgClass, NgStyle } from '@angular/common';
import { Component } from '@angular/core';
import { LanguagesComponent } from '../languages/languages.component';
import { UserComponent } from '../user/user.component';

@Component({
    selector: 'app-top-header',
    imports: [LanguagesComponent, UserComponent, NgClass],
    templateUrl: './top-header.component.html',
    styleUrl: './top-header.component.scss'
})
export class TopHeaderComponent {
    customerLogo = (localStorage.getItem('loginCustomerLogo') && navigator.onLine)
        ? localStorage.getItem('loginCustomerLogo')
        : 'assets/images/logo/logo.png';
}
